import React from 'react';
import { Link } from 'react-router-dom';
import furnitureImage from '../images/furniture.avif';
import appliancesImage from '../images/appliances.avif';
import combosImage from '../images/combos.avif';

const CategoriesSection = () => {
  const categories = [
    {
      id: 1,
      title: "Furniture",
      description: "Create your dream home",
      image: furnitureImage,
      link: "/furniture",
      bgColor: "from-gray-100 to-gray-200"
    },
    {
      id: 2,
      title: "Appliances",
      description: "Function better with appliances",
      image: appliancesImage,
      link: "/appliances",
      bgColor: "from-gray-200 to-gray-300"
    },
    {
      id: 3,
      title: "Combos",
      description: "Save more! Have More!",
      image: combosImage,
      link: "/combos",
      bgColor: "from-gray-300 to-gray-400"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
            Popular Categories
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover Your Perfect Match: Choose from a Wide Range of Categories
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={category.link}
              className="group block"
            >
              <div className="relative bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-6 lg:p-8 h-64 lg:h-80 overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200">
                
                {/* Background Pattern */}
                <div className="absolute inset-0 opacity-5">
                  <div className="absolute top-4 right-4 w-16 h-16 bg-gray-400 rounded-full"></div>
                  <div className="absolute bottom-8 left-8 w-8 h-8 bg-gray-400 rounded-full"></div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-24 h-1 bg-gray-400 rotate-45"></div>
                </div>

                {/* Content */}
                <div className="relative z-10 h-full flex flex-col">
                  {/* Text Content */}
                  <div className="flex-1">
                    <h3 className="text-2xl lg:text-3xl font-bold text-gray-800 mb-2 group-hover:text-gray-900 transition-colors duration-200">
                      {category.title}
                    </h3>
                    <p className="text-gray-600 text-base lg:text-lg group-hover:text-gray-700 transition-colors duration-200">
                      {category.description}
                    </p>
                  </div>

                  {/* Category Image */}
                  <div className="mt-4 lg:mt-6 flex justify-end">
                    <div className="relative w-24 h-24 lg:w-32 lg:h-32 rounded-xl overflow-hidden shadow-lg group-hover:shadow-xl transition-all duration-200 transform group-hover:scale-110">
                      <img 
                        src={category.image} 
                        alt={category.title}
                        className="w-full h-full object-cover object-center"
                      />
                      {/* Image overlay for better text readability */}
                      <div className="absolute inset-0 bg-gradient-to-t from-gray-900 to-transparent opacity-20 group-hover:opacity-30 transition-opacity duration-200"></div>
                    </div>
                  </div>

                  {/* Hover Effect Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 opacity-0 group-hover:opacity-5 transition-opacity duration-300 rounded-2xl"></div>
                </div>

                {/* Corner Accent */}
                <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-br from-gray-900 to-gray-800 opacity-10 group-hover:opacity-20 transition-opacity duration-300 rounded-bl-2xl"></div>
              </div>
            </Link>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12 lg:mt-16">
          <Link 
            to="/categories"
            className="inline-flex items-center bg-gradient-to-r from-gray-900 to-gray-800 text-white px-8 py-4 rounded-xl text-lg font-semibold hover:from-gray-800 hover:to-gray-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <span>Explore All Categories</span>
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection; 